import { statusVariants } from 'components/NudosComponents/BordStatus/BordStatus.type';
import { PAYMENT_TYPES } from '../types/orders';
import { COUNTRY_NAME } from 'types/global';
import { TCustomerChatEntityType } from 'types/customerChat.types';
import { MENTION_TYPES } from 'types/dashboard.types';

export const isDevelopment =
  window.location.hostname.includes('beta') || window.location.host.includes('.dev');
export const isLocalHost = window.location.hostname.includes('localhost');

const LIST_OF_PAYMENT_METHODS = [
  PAYMENT_TYPES.TRANSFER_MXN,
  PAYMENT_TYPES.CARD_MXN,
  PAYMENT_TYPES.TRANSFER_USD,
  PAYMENT_TYPES.INTERNATIONAL_CARD,
  PAYMENT_TYPES.TRANSFER_COP,
  PAYMENT_TYPES.CARD_COP,
  PAYMENT_TYPES.TRANSFER_PEN,
  PAYMENT_TYPES.TRANSFER_ARS,
  PAYMENT_TYPES.CARD_USD_LLC,
  PAYMENT_TYPES.CARD_USD_CORP
];

const PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT = [
  PAYMENT_TYPES.CARD_USD_LLC,
  PAYMENT_TYPES.CARD_MXN,
  PAYMENT_TYPES.INTERNATIONAL_CARD,
  PAYMENT_TYPES.CARD_COP,
  PAYMENT_TYPES.CARD_USD_CORP
];

export enum PAYMENT_METHODS_LABELS {
  CREDIT_BORD = 'Crédito Bord'
}

const PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT_ORDERS = [PAYMENT_TYPES.TRANSFER_MXN];

const PAYMENT_METHODS_THAT_REQUIRE_A_QUOTE_UPLOAD = [
  PAYMENT_TYPES.TRANSFER_MXN,
  PAYMENT_TYPES.TRANSFER_USD,
  PAYMENT_TYPES.TRANSFER_COP,
  PAYMENT_TYPES.TRANSFER_ARS
];

export {
  LIST_OF_PAYMENT_METHODS,
  PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT,
  PAYMENT_METHODS_THAT_REQUIRE_A_QUOTE_UPLOAD,
  PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT_ORDERS
};

export const SWR_KEYS = {
  activeOrdeactiveProducts: 'active-or-deactive-products',
  activeOrdeactiveLoadExternalTool: 'active-ordeactive-load-external-tool',
  catalogExchanges: 'exchange',
  countriesList: 'countries-list',
  countriesOpenForSale: 'countries-open-for-sale',
  update_serials: 'update-serials',
  listOfTools: 'list-of-tools',
  listCountries: 'list-countries',
  update_tool: 'update-tool',
  updateManualQuotation: 'update-manual-quotation',
  mentions: 'mentions',
  organizationConfigList: 'organization-config-list',
  updateConfigurationStatus: 'update-configuration-status',
  deleteConfiguration: 'delete-configuration',
  createStockOrder: 'create-stock-order',
  updateStockOrderBillingData: 'update-stock-order-billing-data',
  createStockOrderInvoice: 'create-stock-order-invoice',
  getStockProductAvailability: 'get-stock-product-availability',
  createReservationStock: 'create-reservation-stock',
  cancelReservationStock: 'cancel-reservation-stock',
  listLSTypes: 'list-ls-types',
  listConfigClasses: 'list-config-classes',
  createPdfToolInformation: 'create-pdf-tool-information',
  employeeOriginTools: 'employee-origin-tools',
  customerChatComments: 'customer-chat-comments',
  currencies: 'currencies'
};

export const CUSTOMER_CHAT_REFRESH_INTERVAL_MS = 60_000;

export const CUSTOMER_CHAT_ALLOWED_ORGANIZATION_IDS: readonly number[] = [754, 7];

export const OPEN_CUSTOMER_CHAT_QUERY_KEY = 'openCustomerChat';

export const CUSTOMER_CHAT_DESCRIPTION_BY_ENTITY: Record<TCustomerChatEntityType, string> = {
  [MENTION_TYPES.ORDER]:
    'Este es un historial de mensajes con el cliente sobre la orden. El chat es visible para todos los usuarios de la organización.',
  [MENTION_TYPES.LOGISTIC_SERVICE]:
    'Este es un historial de mensajes con el cliente sobre el servicio. El chat es visible para todos los usuarios de la organización.'
};

/**
 * Contenedores con scroll propio en detalle de orden/SL que deben bloquearse al abrir el chat lateral.
 * El body ya lo bloquea useLockScroll; el orden prioriza .tabContent sobre el card padre.
 */
export const CUSTOMER_CHAT_BACKGROUND_SCROLL_LOCK_SELECTORS = [
  '#orderDetailsInternalCard .tabContent',
  '.LogisticServiceDetailsTab1General',
  '.logisticServiceDetailsTab4History .boxDetails'
];

export const noDataCopy = 'Sin datos';

export const FALLBACK_FLAG_IMAGE_URL =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/2560px-Flag_of_Mexico.svg.png';

export const metabaseUrl =
  'https://metabase.nudos.co/question/388-catalogo-activo-para-cargue?Modelo=&Procesador=&Memoria=&Almacenamiento=';

export const metabaseUrlProductStock =
  'https://metabase.nudos.co/question/753-productos-en-stock-propio?Pais=&SKU=&Stock_Id=&Estado=&Serial=';

export const VISUAL_EVIDENCE_FILE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'pdf'];

export const VARIANT_SERVICES_STATUS = {
  complete: 'Completado',
  notComplete: 'No completado',
  pending: 'Por completar'
};
export const renderVariantServicesStatus = ({ variant }: { variant: statusVariants | undefined }) => {
  const defaultVariant = 'default';
  const varianStatus = {
    [VARIANT_SERVICES_STATUS.complete]: 'success',
    [VARIANT_SERVICES_STATUS.notComplete]: 'danger',
    [VARIANT_SERVICES_STATUS.pending]: 'default'
  };

  return varianStatus[variant ?? ''] ?? defaultVariant;
};

export const CURRENCY_CODE_BY_COUNTRY_NAME: Record<COUNTRY_NAME, string> = {
  [COUNTRY_NAME.Argentina]: 'ARS',
  [COUNTRY_NAME.Brasil]: 'BRL'
};

export const PAGINATION_INITIAL_PAGE = 1;
